<p-toast></p-toast>
<div class="mi-challan-container">
    <div class="card card-container">
        <!-- <div class="card flex-wrap justify-content-between"> -->
        <!-- <div class="card flex-wrap justify-content-between"> -->
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-6">
                <h4 class="mt-3 ">{{'SELECT_VENDOR'| translate}}</h4>
            </div>


            <div class="field col-12 md:col-6 grid">
                <!-- <div class="flex justify-content-center"> -->
                <label class="mx-4" htmlFor="appId"><b>{{'SELECT_VENDOR'| translate}}</b></label>
                <!-- </div> -->
                <!-- <div class="flex justify-content-center mt-3"> -->
                <p-dropdown [options]="vendorList" [(ngModel)]="selectedVendor" optionLabel="Vendor_Name"
                    (onChange)="onSelectVendor()" placeholder="{{'SELECT_VENDOR'| translate}}"
                    [style]="{'width':'20vw'}"></p-dropdown>
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>

<div class="card" *ngIf="showVendorDetails">
    <app-vendor-price-rate-list-details [vendorDetails]="selectedVendor"></app-vendor-price-rate-list-details>
</div>
